module.exports = __webpack_public_path__ + "static/media/18.02c54a99.jpg";